module.exports = __webpack_public_path__ + "84a39e0729ea71b97412ba4a4cbf8324.png";